import React from 'react'
import BlogList from '../components/BlogList'

function Blogs() {
  return (
    <div className='px-4 container mx-auto flex flex-col gap-8 items-center mt-24'>
      <BlogList />
    </div>
  )
}


export default Blogs
